module.exports = __webpack_public_path__ + "static/media/Rimbayu-Starling Type D - 10-min.18c7d2d7.jpg";